import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

fetch(environment.configFile)
.then(response => response.json())
.then(config => {
  (window as any).__env = config;
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
